import { useParams } from "react-router-dom"
import { SeriesLibrary } from "source/publishing/sermons/SeriesLibrary"
import {
  BreadcrumbNavigation,
  BreadcrumbPage,
  BreadcrumbDividerIcon,
} from "source/shared/components"
import useNotifyNativeLoaded from "source/shared/hooks/useNotifyNativeLoaded"
import OpenGraphTags from "source/shared/OpenGraphTags"
import { useQRCode } from "source/shared/QRCode"
import { Heading } from "@planningcenter/doxy-web"
import NativeHeader from "source/shared/NativeHeader"
import { useSuspenseQuery } from "@tanstack/react-query"
import { sessionApiClient } from "@planningcenter/cc-api-client"
import { unlessCommonError } from "source/CommonErrorBoundary"

export function SeriesList() {
  const { channelId } = useParams()
  const channelUrl = `/publishing/v2/channels/${channelId}/`
  const { data: channel } = useSuspenseQuery({
    queryKey: [channelUrl],
    queryFn: () => sessionApiClient.get(channelUrl),
    retry: unlessCommonError,
    select: (data) => data.data,
  })

  useNotifyNativeLoaded()
  useQRCode()

  return (
    <div className="d-f fd-c g-2">
      <OpenGraphTags title={`${channel.attributes.name} Sermon Series`} />
      <NativeHeader
        title="Series"
        rightType={"share"}
        shareUrl={`${channel.attributes.church_center_url}/series`}
      />
      <BreadcrumbNavigation>
        <BreadcrumbPage
          linkUrl={`/channels/${channel.id}`}
          pageText={channel.attributes.name}
        />
        <BreadcrumbDividerIcon />
        <BreadcrumbPage pageText="Series" isActive />
      </BreadcrumbNavigation>
      <Heading level={1} text="Series" />
      <SeriesLibrary
        channelId={channel.id}
        queryParams={{
          filter: "published,with_published_episodes",
          order: "-ended_at",
        }}
      />
    </div>
  )
}
